import type { GridCellParams } from "@mui/x-data-grid-premium";
import { useTypedSelector } from "hooks";
import { Filters, MenuItem, filters } from "consts/consumers";
import { FilterVariant, date } from "consts/filters";
import { selectIsConsumersLoading } from "features/consumers/selectors";
import { useWhiteListedConsumersActions } from "features/consumers/actions";
import { useConsumerContext } from "../../ConsumerProvider";
import { downloadWhitelistedConsumersCsv } from "features/consumers/api";

export default function useWhitelistedConsumersTable() {
    const isConsumersLoading = useTypedSelector(selectIsConsumersLoading(MenuItem.WhiteListed));

    const { selectionModel, setSelectionModel } = useConsumerContext();

    const {
        getConsumers,
        downloadCsv
    } = useWhiteListedConsumersActions();

    const whitelistedConsumers = filters.get(MenuItem.WhiteListed)!;

    const filterTypes = new Map<FilterVariant, string[]>([
        [FilterVariant.Text, whitelistedConsumers[FilterVariant.Text]!],
        [FilterVariant.DateRange, date],
        [FilterVariant.MultiOption, whitelistedConsumers[FilterVariant.MultiOption]!]
    ]);

    const isRowSelectable = () => !isConsumersLoading;

    const CellProps = {
        [Filters.fileKey]: {
            getCellProps: ({ row }: GridCellParams) => ({
                downloadFile: (fileKey: string) => downloadWhitelistedConsumersCsv({
                    pki: row.pki,
                    fileKey
                })
            })
        }
    };

    return {
        isConsumersLoading,
        filterTypes,
        selectionModel,
        isRowSelectable,
        getConsumers,
        downloadCsv,
        setSelectionModel,
        CellProps
    };
};
